import type { BatchStats } from '@/hooks/useBatchUpload';
import React from 'react';

export interface UploadStatsFooterProps {
  stats: BatchStats;
}

const UploadStatsFooter: React.FC<UploadStatsFooterProps> = ({ stats }) => {
  if (stats.total <= 0) return null;

  return (
    <div className="px-3 py-1.5 border-t border-white/[0.04] flex items-center gap-3">
      {stats.completed > 0 && (
        <span className="text-[10px] text-emerald-400/70">
          {stats.completed} added
        </span>
      )}
      {stats.duplicates > 0 && (
        <span className="text-[10px] text-amber-400/70">
          {stats.duplicates} already in library
        </span>
      )}
      {stats.failed > 0 && (
        <span className="text-[10px] text-red-400/70">
          {stats.failed} failed
        </span>
      )}
    </div>
  );
};

export default UploadStatsFooter;
